<script>
  
  import { redirect } from "../pager";
  import { fade } from "svelte/transition";
	import MapShopList from "../components/map/MapShopList.svelte"  
  import Navigationbar from "../components/Navigationbar.svelte";
  //liblary 
  import { session } from "../components/js/notif.js";
  let settings;
  session.subscribe((value) => {
    settings = value;
  });
  

  //scroll to top every page load
  window.scroll({
    top: 0,
    left: 0,
    behavior: "smooth",
  });

  //navigation
  let navigation = [];
  $: if (settings.loggedin == true) {
    if (settings.data.pen != undefined) {
      navigation["message"] = settings.data.pen.nm;
    } else {
      navigation["message"] = "Selamat Datang";
    }
  } else {
    navigation["message"] = "Selamat Datang";
  }

</script>
<svelte:head>
<title>Peta Ke Dekatan</title>
</svelte:head>
<div class="lg:hidden block" style="z-index:9999; position:fixed; top:0; left:0;right:0;">
<Navigationbar
  backbtn="true"
  message={navigation['message']}
  title="Peta Belanja" />
</div>
<main transition:fade  class="container pt-16 mx-auto mb-5 px-2" style="">
  
  <div class="font-bold justify-center mb-2 lg:flex hidden">
    <img on:click={()=>redirect('/')}
      src="./assets/logo/logo.svg"  width="274" height="64"
      alt="logo"
      class="h-20 bg-white rounded-lg shadow-lg py-2 cursor-pointer" />
  </div>
  <h2 class="text-1xl text-center text-gray-700 mb-4">
    Peta 
    <b>Belanja</b>
    
  </h2>
  <div class="mx-auto px-3 py-5 bg-white rounded-lg shadow-lg">
    <div class="flex flex-wrap wrap-extended mx-auto">
      <MapShopList></MapShopList>

    </div>
  </div>
</main> 
